<template>
<panel>
  <p slot="header">
    Konta do wysyłania
  </p>
  <p slot="actions">
    <ui-button type="flat" icon="add_circle" color="primary" @click.prevent="$router.push({name: 'admin.accounts.create'})">Dodaj konto</ui-button>
  </p>
  <accounts-list></accounts-list>


</panel>

</template>
<script>
import Accounts from '../../services/Accounts'
import EventEmitter from './../../services/EventEmitter'
export default {
  data () {
    return {
      modal: {
        show: false,
        title: 'Dodaj konto',
        baseCreateTitle: 'Dodaj konto',
        baseUpdateTitle: 'Edytuj konto'
      },
      item: Accounts.getBaseItem()
    }
  },
  methods: {
    onAccountsChange (e) {
      this.modal.show = false
      EventEmitter.$emit('accounts.reload', e)
    }
  }
}

</script>


// WEBPACK FOOTER //
// Dashboard.vue?feb420c4